import type { SDKAvailability } from '../types';
import { sdkAvailabilitySchema } from '../types';

export function assertSDKAvailability(value: unknown): asserts value is SDKAvailability {
  sdkAvailabilitySchema.parse(value);
}
